import { render, staticRenderFns } from "./fixed_categories.vue?vue&type=template&id=3a1367dc&scoped=true&"
import script from "./fixed_categories.vue?vue&type=script&lang=js&"
export * from "./fixed_categories.vue?vue&type=script&lang=js&"
import style0 from "./fixed_categories.vue?vue&type=style&index=0&id=3a1367dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1367dc",
  null
  
)

export default component.exports